import { createSlice } from "@reduxjs/toolkit";
import {
  trackBandViewBuilder,
  getBandViewStatsBuilder,
  getMostViewedBandsBuilder,
} from "./builder";

const initialState = {
  trackView: {
    data: null,
    loading: false,
    error: null,
  },
  viewStats: {
    data: null,
    loading: false,
    error: null,
  },
  mostViewed: {
    data: null,
    loading: false,
    error: null,
  },
};

const viewTrackingSlice = createSlice({
  name: "viewTracking",
  initialState,
  reducers: {
    clearTrackView: (state) => {
      state.trackView.data = null;
      state.trackView.error = null;
    },
    clearViewStats: (state) => {
      state.viewStats.data = null;
      state.viewStats.error = null;
    },
    clearMostViewed: (state) => {
      state.mostViewed.data = null;
      state.mostViewed.error = null;
    },
  },
  extraReducers: (builder) => {
    trackBandViewBuilder(builder);
    getBandViewStatsBuilder(builder);
    getMostViewedBandsBuilder(builder);
  },
});

export const { clearTrackView, clearViewStats, clearMostViewed } =
  viewTrackingSlice.actions;

export const selectTrackView = (state) => state.viewTracking.trackView;
export const selectViewStats = (state) => state.viewTracking.viewStats;
export const selectMostViewed = (state) => state.viewTracking.mostViewed;

export const selectTrackViewLoading = (state) =>
  state.viewTracking.trackView.loading;
export const selectViewStatsLoading = (state) =>
  state.viewTracking.viewStats.loading;
export const selectMostViewedLoading = (state) =>
  state.viewTracking.mostViewed.loading;

export const selectTrackViewData = (state) => state.viewTracking.trackView.data;
export const selectViewStatsData = (state) => state.viewTracking.viewStats.data;
export const selectMostViewedData = (state) => state.viewTracking.mostViewed.data;

export default viewTrackingSlice.reducer;